import tagTester from './_tagTester.js';

export default tagTester('String');



//////////////////
// WEBPACK FOOTER
// ./~/underscore/modules/isString.js
// module id = 279
// module chunks = 9